<template>
    <div class="lp_StepsLine">
        <ul>
            <li v-for="(item,index) in listData" :key="index" :class="step!==index?'gray':''">
                <p><span>{{item.num}}</span></p>
                <span>{{item.name}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
  export default {
    name: "lp_StepsLine",
    props:{
      step:{ 
        type:Number,
        default:0
      }
    },
    data () {
      return{
          listData:[{name:'忘记密码',num:1,isshow:true},{name:'设置密码',num:2,isshow:false}],
      }
    },
    methods: {
      //查看更多
      moreClick(){
        this.$router.push({path:moreHref});
      }
    },
  }
</script>

<style scoped lang="less">
 .lp_StepsLine{
     height: 80px;
     width: 70%;
     ul{
         width: 100%;
         height: 100%;
         display: flex;
         align-items: center;
         justify-content: space-around;
         text-align: center;
         border-bottom: 2px solid #DEE3E6;
         box-sizing: border-box;
         .gray{
            border-bottom: 2px solid transparent;
             p{
                 background: #E8E8E8;
                 span{
                     color: #999999;
                 }
             }
             span{
                 color: #999999;
             }
         }
         li{
             display: flex;
             align-items: center;
             text-align: center;
             justify-content: center;
             width: 30%;
             height: 100%;
             border-bottom: 2px solid #1582F3;
             box-sizing: border-box;
             @heightStep:40px;
             p{
                 width: @heightStep;
                 height: @heightStep;
                 transform: rotate(-45deg);
                background: rgba(21,130,243,0.15);
                border-radius: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 20px;
                span{
                    transform: rotate(45deg);
                    width: @heightStep;
                    height: @heightStep;
                    line-height: @heightStep;
                    font-family: PingFangSC-Semibold;
                    font-size: 18px;
                    color: #1582F3;
                    text-align: center;
                }
             }
             span{
                 font-family: AlibabaPuHuiTiM;
                font-size: 18px;
                color: #1582F3;
                text-align: center;
                line-height: 16px;
             }
         }
     }
 }
</style>


// WEBPACK FOOTER //
// src/components/stepsline/index.vue